import { ChartIcon } from '@approvalmax/ui';
import { domain } from 'modules/data';
import { useMemo } from 'react';
import bemFactory from 'react-bem-factory';
import { DomainIntegrationType, useGetCompany } from 'shared/data/webApp/v2';
import { useCompanyBetaFeatures } from 'shared/hooks';
import { getPath, Path } from 'urlBuilder';

import { messages } from './ReportsMenu.messages';

const qa = bemFactory.qa('reportsDropdown');

export const useReportsLinkItems = (companyId: string) => {
    const { data: company } = useGetCompany({ path: { companyId } });

    const { isNetSuiteLineLevelReports } = useCompanyBetaFeatures(companyId);

    return useMemo(
        () =>
            company
                ? [
                      {
                          id: 'reports',
                          name: messages.reportsName,
                          startIcon: ChartIcon,
                          dataQa: qa(),
                          subItems: [
                              {
                                  id: domain.ReportType.Request,
                                  name: messages.requestName,
                                  to: getPath(Path.reportsDashboard, company.id, domain.ReportType.Request),
                                  dataQa: qa('navigationItem'),
                                  dataQaName: 'reports',
                              },
                              {
                                  id: domain.ReportType.LineItem,
                                  name: messages.lineItemsName,
                                  available:
                                      company.integrationType === DomainIntegrationType.Xero ||
                                      company.integrationType === DomainIntegrationType.QBooks ||
                                      (company.integrationType === DomainIntegrationType.NetSuite &&
                                          isNetSuiteLineLevelReports),
                                  to: getPath(Path.reportsDashboard, company.id, domain.ReportType.LineItem),
                                  dataQa: qa('navigationItem'),
                                  dataQaName: 'lineItemReports',
                              },
                          ],
                      },
                  ]
                : [],
        [company, isNetSuiteLineLevelReports]
    );
};
